/*
 Author: WebSensePro
 Title:	Light-Zoom JQuery plugin that use pure css to zoom on images, this enables you to zoom without loading bigger image and zoom even on gif images !
 */

/* 
    This is the Zoom used in our product pages. The css style is at the bottom of theme.css, it can be found by the '.image-selector'.
    lightzoom is being used on the following pages, with the class='image-selector'
        media.liquid
    jQuery is inserted in the theme.liquid file. The zoom function will work on pages that have 'product' or 'collection' in the template name. If a new template is created where the zoom is needed,
    a keyword will have to the following 'if' statement in the theme.liquid file.
    {% if template contains 'product' or 'collection' %}

    To make changes to the amount of zoom or size, it should be edited in the following function at the bottom of this page.
    $(".image-selector").lightzoom({
      zoomPower: 3,
      glassSize: 200,
    });
*/
/**
 * This Checks to see if the mouse is over the navbar... if it is the zoom will not display
 */
$(".headerContainer").hover(function () {
  // console.log("==========YOU ENTERED THE HEADER================");
  $("#glass").css("display", "none");
  $("body").css("cursor", "default");
});

$(document).ready(function ($) {
  $.fn.lightzoom = function (options) {
    var settings = $.extend(
      {
        zoomPower: 2.5,
        glassSize: 350,
      },
      options
    );

    var halfSize = settings.glassSize / 2;
    var quarterSize = settings.glassSize / 4;

    var zoomPower = settings.zoomPower;

    $("body").append('<div id="glass"></div>');
    $("html > head").append(
      $(
        "<style> #glass{width: " +
          settings.glassSize +
          "px; height: " +
          settings.glassSize +
          "px;}</style>"
      )
    );

    var faker;
    var obj = this;

    $("#glass").mousemove(function (event) {
      var obj = this.targ;
      event.target = obj;
      faker(event, obj);
    });

    this.mousemove(function (event) {
      faker(event, this);
    });
    faker = function (event, obj) {
      //console.log(obj);
      document.getElementById("glass").targ = obj;
      var mx = event.pageX;
      var my = event.pageY;
      var bounding = obj.getBoundingClientRect();
      var w = bounding.width;
      var h = bounding.height;
      var objOffset = $(obj).offset();
      var ol = objOffset.left;
      var ot = objOffset.top;
      if (mx > ol && mx < ol + w && ot < my && ot + h > my) {
        offsetXfixer = ((mx - ol - w / 2) / (w / 2)) * quarterSize;
        offsetYfixer = ((my - ot - h / 2) / (h / 2)) * quarterSize;
        var cx = ((mx - ol + offsetXfixer) / w) * 100;
        var cy = ((my - ot + offsetYfixer) / h) * 100;
        my -= halfSize;
        mx -= halfSize;
        $("#glass").css({
          top: my,
          left: mx,
          "background-image": " url('" + obj.src + "')",
          "background-size": w * zoomPower + "px " + h * zoomPower + "px",
          "background-position": cx + "% " + cy + "%",
          display: "inline-block",
        });
        $("body").css("cursor", "none");
      } else {
        $("#glass").css("display", "none");
        $("body").css("cursor", "default");
      }
    };
    return this;
  };
});
// Edit zoom and size here. Keep glassSize over 300 going under will introduce a bug where the zoom will get stuck on the screen
$(document).ready(function ($) {
  $(".image-selector").lightzoom({
    zoomPower: 2.5,
    glassSize: 350,
  });
});

/**
 * If the mouse moves out of the image it will help remove the zoom lense
 */

$(document).ready(function () {
  let imageCon = $(".image-selector")[0];
  let imgWidth = imageCon.clientWidth;
  let imgHeight = imageCon.clientHeight;
  //This sets the initial position of the image
  let imgPosition = offset(imageCon, imgWidth, imgHeight);

  document.onmousemove = (event) => {
    const { clientX, clientY } = event;
    //updates the position of the image when the user scolls.
    window.addEventListener("scroll", () => {
      imgPosition = offset(imageCon, imgWidth, imgHeight);
    });
    if (
      imgPosition.topLeft.y <= clientY &&
      clientY <= imgPosition.bottomRight.y &&
      imgPosition.topLeft.x <= clientX &&
      clientX <= imgPosition.bottomRight.x
    ) {
    } else {
      $("#glass").css("display", "none");
      $("body").css("cursor", "default");
    }
  };
    window.addEventListener("resize", (event) => {
    imgPosition = offset(imageCon, imgWidth, imgHeight);
    const { clientX, clientY } = event;
    if (
      imgPosition.topLeft.y <= clientY &&
      clientY <= imgPosition.bottomRight.y &&
      imgPosition.topLeft.x <= clientX &&
      clientX <= imgPosition.bottomRight.x
    ) {
    } else {
      $("#glass").css("display", "none");
      $("body").css("cursor", "default");
    }
  });
});

function offset(el, imgWidth, imgHeight) {
  var rect = el.getBoundingClientRect();
  // scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
  // scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  scrollLeft = window.scrollX || document.documentElement.scrollLeft;
  scrollTop = window.scrollY || document.documentElement.scrollTop;
  let top = rect.top + scrollTop;
  let left = rect.left + scrollLeft;
  //measures the scroll distance from the top of the page
  let scrollDis = $(window).scrollTop();
  // return { top: rect.top + scrollTop, left: rect.left + scrollLeft };

  return {
    topLeft: {
      x: left,
      y: top - scrollDis,
    },
    topRight: {
      x: left + imgWidth,
      y: top - scrollDis,
    },
    bottomLeft: {
      x: left,
      y: top + imgHeight - scrollDis,
    },
    bottomRight: {
      x: left + imgWidth,
      y: top + imgHeight - scrollDis,
    },
  };
}


